import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"

class BasketNumber extends Component {
    render() {
        const {number} = this.props


        return (
            <span className='BasketNumber'>
                {number}
            </span>
        )
    }
}

BasketNumber.propTypes = {
    number: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
}

export default BasketNumber
